import { SettingsMessages, TranslationSettingsMessages } from "../interfaces";

export const messages: TranslationSettingsMessages = {
  [SettingsMessages.settingsTitle]: "Settings",
  [SettingsMessages.parameters]: "Parameters",
  [SettingsMessages.timeForUndueStopOptionDescription]: "Time needed for a vehicle stop to be considered undue",
  [SettingsMessages.timeForUndueStopOptionHelper]:
    "A vehicle stopped outside a registered location for longer than this is flagged as an undue stop.",
  [SettingsMessages.functionalities]: "Functionalities",
  [SettingsMessages.enablePumpTimelineOptionDescription]: "Enable pump map",
  [SettingsMessages.enablePumpTimelineOptionHelper]:
    "Shows the \"Pumps\" item (pump timeline) in the system menu.",
  [SettingsMessages.enableWaterPostDischargeOptionDescription]: "Assign post-discharge water additions to the next travel",
  // eslint-disable-next-line max-len
  [SettingsMessages.enableWaterPostDischargeOptionHelper]: "When on, water added after the discharge (\"fine\" water reused in the next load) is no longer counted on the current travel and is assigned to the vehicle's next travel instead — shown in a separate block with a reference to the origin travel. When off, the water stays on the current travel (default behavior).",
  [SettingsMessages.blockDate]: "Block date",
  [SettingsMessages.blockDateHelper]:
    "Blocks system access from this date onward (administrative use, e.g. overdue payment). Empty = no block.",
  [SettingsMessages.minutes]: "Minutes",
  [SettingsMessages.defaultConstructionRadiusOptionDescription]: "Default construction radius used when a construction has no radius of its own",
  [SettingsMessages.meters]: "Meters",
  [SettingsMessages.autoTravelMinStopMinutes]: "Minimum stopped time to enter a construction (automatic travel, in minutes)",
  [SettingsMessages.timeForImproperDischargeOptionDescription]: "Minimum duration of a discharge outside a jobsite to raise an alert",
  [SettingsMessages.timeForImproperDischargeOptionHelper]:
    "A discharge outside a registered location shorter than this does not raise an alert. It keeps a flickering sensor on a moving truck from raising one.",
  [SettingsMessages.seconds]: "Seconds",
};
